module.exports = __webpack_public_path__ + "img/service5.28ea4621.jpg";